import { filterClasses } from "@swivl-mono/helpers";
import React, { ReactNode } from "react";

import { buildRequestAccessMailtoHref } from "../../../../Helpers/RequestAccessMailto";
import NotificationsModel from "../../../../Models/Notifications/Notifications.Model";

// Shared copy for every locked action — one place to reword.
export function showBlockedActionToast(action: string): void {
  NotificationsModel.createToastNotification({
    message: `${action} requires a swivl login.`,
    action: { label: "Request Access", href: buildRequestAccessMailtoHref() },
    iconDismiss: true
  });
}

// Toasts instead of calling handler when locked — used by every click-to-edit field.
export function lockableClick(locked: boolean | undefined, action: string, handler: () => void): () => void {
  return () => (locked ? showBlockedActionToast(action) : handler());
}

type TicketPropertyRowProps = {
  label: ReactNode;
  icon?: ReactNode;
  children: ReactNode;
  pending?: boolean;
  /** Helper text rendered beneath the value; top-aligns the row when set. */
  hint?: ReactNode;
  /** Set to grey out this row and toast on click. */
  lockedAction?: string;
};

export function TicketPropertyRow({ label, children, pending, hint, lockedAction }: TicketPropertyRowProps) {
  return (
    <div className={filterClasses("flex gap-6", hint ? "items-start" : "items-center")}>
      <div className={filterClasses("body-sm w-20 shrink-0 text-[#707070]", hint ? "pt-0.5" : "")}>{label}</div>
      <div className="min-w-0 flex-1">
        <div
          className={filterClasses("body-sm flex items-center text-black", lockedAction && "cursor-not-allowed text-grey-500")}
          onClick={lockedAction ? () => showBlockedActionToast(lockedAction) : undefined}
        >
          {children}
          {pending && <span className="ml-2 text-xs text-[#a8a8a8]">saving…</span>}
        </div>
        {hint}
      </div>
    </div>
  );
}
